// extracted by mini-css-extract-plugin
export var boxItems = "_55-1";
export var boxItemsLg = "_55-2";
export var button = "_55-7";
export var buttonLg = "_55-8";
export var filterGroupBox = "_55-0";
export var icon = "_55-3";
export var iconSecondary = "_55-6";
export var iconWrapper = "_55-4";
export var iconWrapperLg = "_55-5";